module.exports = __webpack_public_path__ + "static/img/中雨转大雨.b47fd449.svg";